import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { EMPTY, Observable, of, switchMap } from 'rxjs';
import { RouteParam } from '@core/routing/routes/enums/route-param';
import { Route } from '@core/routing/routes/enums/route';
import { isNil } from '@core/utils/nil/is-nil';
import { Sequence } from '@features/sequence/models/sequence';
import { SequenceActionService } from '@features/sequence/services/sequence-action.service';
import { NavigatorService } from '@core/routing/routes/services/navigator.service';

export const SequenceResolver: ResolveFn<Sequence> = (
  route
): Observable<Sequence> => {
  const action = inject(SequenceActionService);
  const navigator = inject(NavigatorService);
  const id = route.paramMap.get(RouteParam.SequenceId);

  return of(id).pipe(
    switchMap(id => {
      if (isNil(id)) {
        navigator.navigateByRouterLink(provider =>
          provider.routerLink(Route.NotFound)
        );

        return EMPTY;
      }

      return action.fetch(id);
    })
  );
};
